import { Component } from '@angular/core';
import { AbstractControl, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { WebapiService } from '../shared/services/webapi.service';
import { ToastrService } from 'ngx-toastr';
import { CustomValidators } from '../shared/validators/CustomValidators';

@Component({
  selector: 'app-signup-c',
  templateUrl: './signup-c.component.html',
  styleUrls: ['./signup-c.component.scss']
})
export class SignupCComponent {
  formSubmitting=false;
  countries:any=[];
  plans:any;
  maxBirthdayDate = new Date();
  choreographerForm: FormGroup = this.fb.group({
    email: ['', Validators.compose([Validators.required, Validators.email])],
    password: ['', Validators.compose([Validators.required, Validators.minLength(8)])],
    re_password: ['', Validators.compose([Validators.required,Validators.minLength(8)])],
    first_name: ['', Validators.compose([Validators.required])],
    last_name: ['', Validators.compose([Validators.required])],
    dob: ['', Validators.compose([Validators.required, CustomValidators.noFutureDateValidator])],
    country: ['', Validators.compose([Validators.required])],
    form_type: ['choreographer'],
    plan:['',Validators.compose([Validators.required])],
    trial:[0]
  },
  { validators: CustomValidators.MatchValidator('password', 're_password') });

  constructor(private fb: FormBuilder, public webApi: WebapiService, private toastrService: ToastrService, public router: Router) {
    this.getCountries()
    this.getPlans()
    this.choreographerForm.get('trial').valueChanges.subscribe(val => {
      if (val==0) {
        this.choreographerForm.controls['plan'].setValidators([Validators.required]);
      } else {
        this.choreographerForm.controls['plan'].clearValidators();
      }
      this.choreographerForm.controls['plan'].updateValueAndValidity();
    },
    error => {
      this.toastrService.error("unable to handle response");
    });
    this.maxBirthdayDate.setFullYear( this.maxBirthdayDate.getFullYear() - 18 );
  }


  getPlans(){
    this.webApi.getPlans('choreographer').subscribe((data: any) => {
      if (data.success) {
        let dataplans=data.plans;
        this.plans = dataplans;

        //this.webApi.setSession(data);
        //this.router.navigateByUrl('/');
      } else {
        this.toastrService.error(data.message);
      }
    },
    error => {
      this.toastrService.error("unable to handle response");
    });
  }

  onSigup(form: FormGroup) {
    console.log(this.webApi.getErrors(form))
    if (form.valid && !this.formSubmitting) {
      this.formSubmitting=true;
      if(form.value.plan==""){
        form.value.trial=1
      }
      let trial=form.value.trial
      form.value.dob = this.webApi.formatDate(form.value.dob)
      this.webApi.signup(form.value).subscribe((data: any) => {
        if (data.success) {
          form.reset();
					this.toastrService.success(data.message);
          if(trial!=1 && data.redirecturl && data.redirecturl!=""){
            window.location.href=data.redirecturl;
          }
          //this.webApi.setSession(data);
          //this.router.navigateByUrl('/');
        } else {
					this.toastrService.error(data.message);
        }
        this.formSubmitting=false;
      },
      error => {
        this.toastrService.error("unable to handle response");
        this.formSubmitting=false;
      });
    } else {
      this.webApi.validateAllFields(form);
    }
  }

  getCountries(){
    this.webApi.getCountries().subscribe((data: any) => {
      if (data.success) {
        this.countries=data.countries;
        //this.webApi.setSession(data);
        //this.router.navigateByUrl('/');
      } else {
        alert(data.message)
      }
    },
    error => {
      this.toastrService.error("unable to handle response");
    });
  }

  get f2(): { [key: string]: AbstractControl } {
    return this.choreographerForm.controls;
  }
}


